// removed by extract-text-webpack-plugin
module.exports = {"page":"_2vr_6ld35FJoabQIHX_iL2"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/opportunityPage.less
// module id = 628
// module chunks = 0